import type { LayerKey } from '@festina-life/api'
import { useTranslate, useTranslateEnum } from '@festina-life/ui/hooks'

import { useLayoutContext } from '../../../context/layoutContext'
import {
  isConfigurationValueSetupField,
  type TemplateField,
} from '../../../types/templateModel'
import { TemplatePath } from '../../path/TemplatePath'
import { useFieldDocumentation } from '../../templateFieldDocumentation/useFieldDocumentation'

type Props = {
  field: TemplateField
  layer: LayerKey
  block: string
}

export const TemplateFieldTitle = ({ field, layer, block }: Props) => {
  const translate = useTranslate()
  const translateEnum = useTranslateEnum()
  const { modelFieldType } = useFieldDocumentation(field)
  const {
    preferences: { common },
  } = useLayoutContext()

  const renderTitle = () => {
    if (isConfigurationValueSetupField(field)) {
      return translate('templateViewer.details.title.configurationOnly')
    }

    return translateEnum('enum.ValueSetupRole', field.role)
  }

  return (
    <div className="flex w-full flex-col gap-y-2">
      <div>
        <TemplatePath
          block={block}
          layer={layer}
          value={field.path}
          className="text-sm"
          variant={common.isUsingModal ? 'contrast' : 'normal'}
          isInteractive
        />
      </div>
      <div className="flex gap-x-2">
        <div>{modelFieldType}</div>
        <div className="text-lg italic text-gray-400">{renderTitle()}</div>
      </div>
    </div>
  )
}
